import React from 'react'
import { PageTitle } from '_metronic/layout/core'
import { WithChildren, KTSVG } from '_metronic/helpers'
import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import { ClientSideTable } from 'Presentation/Components/Table'
import Filter from './Components/Filter'

import useViewModel from './ViewModel'

const PileListView: React.FC = () => {
  const { data, TABLE_CONFIGS, filter, onAdd, onChangeFilter, onSubmitFilter, onClearFilter } =
    useViewModel()

  return (
    <ViewPageTitle>
      <div className='row gy-5 mb-5'>
        <div className='col-12'>
          <PageBreadCrumb />
          <Filter
            filter={filter}
            onChangeFilter={onChangeFilter}
            onClearFilter={onClearFilter}
            onSubmit={onSubmitFilter}
          />
        </div>

        {/* begin:: Table */}
        <div className='col-12'>
          <div className='card'>
            {/* begin:: Header */}
            <div className='card-header'>
              <div className='card-title w-75'></div>
              {/* end:: Header */}

              <div className='card-toolbar'>
                <button
                  onClick={onAdd}
                  className='btn btn-sm btn-light-success me-4 fw-bold shadow'
                  style={{ whiteSpace: 'nowrap' }}>
                  <KTSVG path='/media/icons/duotune/files/fil018.svg' svgClassName='svg-icon-1' />
                  เพิ่มเสาเข็ม
                </button>

                <button
                  className='btn btn-sm btn-light-primary fw-bold'
                  id='kt_machine_filter_toggle'
                  style={{ whiteSpace: 'nowrap' }}>
                  <KTSVG path='/media/icons/duotune/general/gen004.svg' svgClassName='svg-icon-1' />
                  ค้นหา
                </button>
              </div>
            </div>
            {/* end:: Header */}

            {/* begin:: Body */}
            <div className='card-body horizontal-paddingless'>
              <ClientSideTable isGrey data={data} columns={TABLE_CONFIGS} items_per_page={20} />
            </div>
            {/* end:: Body */}
          </div>
        </div>
        {/* end:: Table */}
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/general/gen005.svg',
          },
        ]}>
        รายการเสาเข็ม
      </PageTitle>

      {children}
    </>
  )
}

export default PileListView
